// push_notifications.js — vanilla JS Web Push subscription management
//
// Usage: add to any element that should trigger subscription:
//   <button id="push-toggle-btn" data-vapid-public-key="<%= ENV['VAPID_PUBLIC_KEY'] %>">
//     Enable Notifications
//   </button>
//   <p id="push-status"></p>

(function () {
  function urlBase64ToUint8Array(base64String) {
    const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
    const base64  = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
    const raw     = atob(base64);
    return Uint8Array.from([...raw].map((c) => c.charCodeAt(0)));
  }

  function csrfToken() {
    return document.querySelector('meta[name="csrf-token"]')?.content;
  }

  function setStatus(statusEl, text) {
    if (statusEl) statusEl.textContent = text;
  }

  function setButtonText(btn, text) {
    if (btn) btn.textContent = text;
  }

  async function subscribe(btn, statusEl, vapidPublicKey) {
    try {
      const reg = await navigator.serviceWorker.register("/sw.js");
      const sub = await reg.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: urlBase64ToUint8Array(vapidPublicKey),
      });
      const { endpoint, keys } = sub.toJSON();

      const res = await fetch("/push_subscriptions", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": csrfToken(),
        },
        body: JSON.stringify({ endpoint, p256dh: keys.p256dh, auth: keys.auth }),
      });

      if (res.ok) {
        setStatus(statusEl, "Subscribed! You will receive push notifications.");
        setButtonText(btn, "Unsubscribe");
      } else {
        await sub.unsubscribe();
        setStatus(statusEl, "Subscription failed. Please try again.");
      }
    } catch (err) {
      console.error("Push subscribe error:", err);
      setStatus(statusEl, "Could not subscribe. Please try again.");
    }
  }

  async function unsubscribe(sub, btn, statusEl) {
    await fetch("/push_subscriptions", {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": csrfToken(),
      },
      body: JSON.stringify({ endpoint: sub.endpoint }),
    });
    await sub.unsubscribe();
    setStatus(statusEl, "Unsubscribed from push notifications.");
    setButtonText(btn, "Enable Notifications");
  }

  async function init(btn) {
    const statusEl       = document.getElementById("push-status");
    const vapidPublicKey = btn.dataset.vapidPublicKey;

    if (!("serviceWorker" in navigator) || !("PushManager" in window)) {
      setStatus(statusEl, "Push notifications are not supported in this browser.");
      btn.disabled = true;
      return;
    }

    if (Notification.permission === "denied") {
      setStatus(statusEl, "Notifications are blocked. Please allow them in your browser settings.");
      btn.disabled = true;
      return;
    }

    // Reflect existing subscription state on page load
    const reg      = await navigator.serviceWorker.register("/sw.js");
    const existing = await reg.pushManager.getSubscription();
    if (existing) {
      setStatus(statusEl, "You are subscribed to push notifications.");
      setButtonText(btn, "Unsubscribe");
    }

    btn.addEventListener("click", async () => {
      const currentReg = await navigator.serviceWorker.getRegistration("/sw.js");
      const currentSub = currentReg && await currentReg.pushManager.getSubscription();
      if (currentSub) {
        await unsubscribe(currentSub, btn, statusEl);
      } else {
        await subscribe(btn, statusEl, vapidPublicKey);
      }
    });
  }

  document.addEventListener("turbo:load", () => {
    const btn = document.getElementById("push-toggle-btn");
    if (btn) init(btn);
  });
  document.addEventListener("DOMContentLoaded", () => {
    const btn = document.getElementById("push-toggle-btn");
    if (btn) init(btn);
  });
})();
